export default function GallerySection() {
  const galleryImages = [
    {
      title: 'Lớp học Robotics',
      image: 'https://public.readdy.ai/ai/img_res/1f85e8e20176ef2e5d5a54af9c243a5a.jpg'
    },
    {
      title: 'Cuộc thi Robot',
      image: 'https://public.readdy.ai/ai/img_res/fb3312b84e2a3fe84f3d741e9fee0cdc.jpg'
    },
    {
      title: 'Phòng Lab hiện đại',
      image: 'https://readdy.ai/api/search-image?query=Professional%20robotics%20laboratory%20with%20advanced%20equipment%20and%20workstations%2C%20modern%20STEM%20education%20facility%20with%20robot%20arms%20and%20computers%2C%20high-tech%20learning%20environment%20with%20organized%20tools%20and%20devices&width=600&height=400&seq=gallery-003&orientation=landscape'
    },
    {
      title: 'Thực hành lập trình',
      image: 'https://readdy.ai/api/search-image?query=Students%20programming%20robots%20with%20laptops%20and%20microcontrollers%2C%20young%20learners%20coding%20and%20testing%20electronic%20projects%2C%20hands-on%20technology%20education%20with%20Arduino%20and%20sensors&width=600&height=400&seq=gallery-004&orientation=landscape'
    },
    {
      title: 'Sản phẩm học viên',
      image: 'https://readdy.ai/api/search-image?query=Completed%20student%20robot%20projects%20display%20with%20various%20autonomous%20vehicles%2C%20showcase%20of%20innovative%20robotics%20creations%20by%20students%2C%20collection%20of%20smart%20cars%20and%20IoT%20devices%20built%20by%20learners&width=600&height=400&seq=gallery-005&orientation=landscape'
    },
    {
      title: 'Workshop AI & IoT',
      image: 'https://readdy.ai/api/search-image?query=Robotics%20workshop%20with%20instructor%20teaching%20students%20about%20AI%20and%20automation%2C%20mentor%20guiding%20young%20people%20in%20building%20advanced%20robots%2C%20educational%20session%20with%20professional%20equipment%20and%20engaged%20learners&width=600&height=400&seq=gallery-006&orientation=landscape'
    }
  ];

  return (
    <section id="gallery" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Hoạt động & <span className="text-orange-600">Thành tựu</span></h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">Những khoảnh khắc đáng nhớ trong hành trình đào tạo và phát triển kỹ năng công nghệ cho thế hệ trẻ Việt Nam</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryImages.map((item, index) => (
            <div key={index} className="group relative overflow-hidden rounded-xl shadow-md hover:shadow-2xl transition-all duration-300 cursor-pointer">
              <div className="relative h-72 overflow-hidden">
                <img 
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  src={item.image}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <h3 className="text-white font-bold text-lg mb-2">{item.title}</h3>
                  <div className="flex items-center text-white text-sm">
                    <i className="ri-image-line mr-2"></i>
                    <span>Xem chi tiết</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <button className="whitespace-nowrap bg-gradient-to-r from-orange-500 to-orange-600 text-white px-8 py-3 rounded-full font-semibold hover:from-orange-600 hover:to-orange-700 transition-all cursor-pointer inline-flex items-center">
            <i className="ri-gallery-line mr-2"></i>
            Xem thêm hình ảnh
          </button>
        </div>
      </div>

      {/* Partners Section */}
      <div className="max-w-7xl mx-auto px-6 mt-20">
        <div className="bg-white rounded-xl p-8 shadow-lg border border-gray-100">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">Đối tác & Trường học tin tưởng</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="flex flex-col items-center justify-center p-6 bg-orange-50 rounded-lg hover:bg-orange-100 transition-colors group">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center mb-3 group-hover:scale-110 transition-transform">
                <i className="ri-graduation-cap-line text-3xl text-white"></i>
              </div>
              <p className="text-xs text-gray-700 text-center font-medium">Đại học Lâm Nghiệp</p>
            </div>
            <div className="flex flex-col items-center justify-center p-6 bg-orange-50 rounded-lg hover:bg-orange-100 transition-colors group">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center mb-3 group-hover:scale-110 transition-transform">
                <i className="ri-building-line text-3xl text-white"></i>
              </div>
              <p className="text-xs text-gray-700 text-center font-medium">Cao đẳng Sonadezi</p>
            </div>
            <div className="flex flex-col items-center justify-center p-6 bg-orange-50 rounded-lg hover:bg-orange-100 transition-colors group">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center mb-3 group-hover:scale-110 transition-transform">
                <i className="ri-global-line text-3xl text-white"></i>
              </div>
              <p className="text-xs text-gray-700 text-center font-medium">Trung tâm Giáo dục Quốc tế Konnichiwa</p>
            </div>
            <div className="flex flex-col items-center justify-center p-6 bg-orange-50 rounded-lg hover:bg-orange-100 transition-colors group">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center mb-3 group-hover:scale-110 transition-transform">
                <i className="ri-school-line text-3xl text-white"></i>
              </div>
              <p className="text-xs text-gray-700 text-center font-medium">THCS & THPT Trảng Bom</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
